module.exports = __webpack_public_path__ + "img/logo.f9eb5f01.png";